import React from 'react';

import CoreFormElementInputBase from './BaseInput';
import { FormElementSyncRestProps, FormUniqueKey } from '../../factories/';
import { CoreFormElementProps } from '../../interfaces/';
import { FORM_ELEMENT_PROPS, INPUT_TYPE_RADIO } from '../../constants/';
import { HashMapMergeProps } from '../../../../../utils/';

/**
 * Radio Input Element
 * @export
 * @class CoreFormElementRadio
 * @extends {CoreFormElementInputBase}
 */
export default class CoreFormElementRadio extends CoreFormElementInputBase {
  /**
   * Default Props
   * @static
   * @type {Omit<CoreFormElementProps, 'name'>}
   * @memberof CoreFormElementRadio
   */
  public static defaultProps: Omit<CoreFormElementProps, 'name'> = HashMapMergeProps(FORM_ELEMENT_PROPS, {
    type: INPUT_TYPE_RADIO,
    placeholder: null
  });

  /**
   * Render
   * @returns
   * @memberof CoreFormElementRadio
   */
  public render() {
    const { OnChangeOrInput, OnBlur, props } = this;
    const { type, name, value, checked, onChange, onInput, onBlur, ...rest } = props;
    const synced = FormElementSyncRestProps(type, rest);
    const key = FormUniqueKey(type, name, value);
    return <input key={key} type={type} name={name} value={value as any} defaultChecked={checked} onChange={OnChangeOrInput} onBlur={OnBlur} {...synced} />;
  }
}
